import { Theme } from "../../../../components/constants";

export default {
    recipientInformationContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },

    gapBetween: {
        display: 'flex',
        columnGap: '6px',
        alignItems: 'center',
        color: Theme.DISABLED_TEXT
    },

    separator: {
        margin: '0px 10px'
    },

    recipientName: {
        fontSize: '16px',
        marginBottom: '10px'
    },

    detailsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px'
    },

    recipientType: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },

    cursor: {
        cursor: "pointer"
    }
}